import { FieldRenderProps } from 'react-final-form'
import TextEditor, { TextEditorType } from '../../control/textEditor/TextEditor'

type SelectInputProps = FieldRenderProps<TextEditorType[], any>

const TextEditorInput: React.FC<SelectInputProps> = ({ input, meta, ...rest }) => {
    return <TextEditor {...input} {...rest} error={meta.touched && meta.error} helperText={meta.error} />
}

export default TextEditorInput
